// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import AdminPage from './pages/AdminPage';
import PublicPage from './pages/PublicPage';
import DevPage from './pages/DevPage';
import ResourcesPage from './pages/ResourcesPage';
import SeoPage from './pages/SeoPage';
import ContentPage from './pages/ContentPage';
import DesignPage from './pages/DesignPage';
import ReleasePage from './pages/ReleasePage';

// ✅ your release admin page
import ReleaseAdminPage from './pages/ReleaseAdminPage';

import POPPage from './Sections/POPPage/POPPage';

function App() {
  const isAuthenticated = true;

  return (
    <Router>
      <Routes>
        {/* Root path serves ReleaseAdminPage */}
        <Route
          path="/"
          element={isAuthenticated ? <ReleaseAdminPage /> : <Navigate to="/public" replace />}
        />

        <Route path="/public" element={<PublicPage />} />
        <Route path="/dev" element={<DevPage />} />

        <Route
          path="/admin"
          element={isAuthenticated ? <AdminPage /> : <Navigate to="/public" replace />}
        />

        {/* Keep /releaseAdmin as an alias for backwards compatibility */}
        <Route
          path="/releaseAdmin"
          element={isAuthenticated ? <ReleaseAdminPage /> : <Navigate to="/public" replace />}
        />

        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/seo" element={<SeoPage />} />
        <Route path="/design" element={<DesignPage />} />
        <Route path="/content" element={<ContentPage />} />
        <Route path="/release" element={<ReleasePage />} />

        <Route path="/POP" element={<POPPage />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
